export default "/_next/static/chunks/fonts/poppins-v9-latin-ext-500-4b0ee5439287b28586b9aee1c8550034.woff2";